// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { getStorage, setStorage } from "src/lib/storage";
import { GSP_DATA_COLOUR_SCHEMES } from "src/lib/data.js";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";
import { getVarType, makeDate, makeDateNow } from "src/lib/utils.js";


// Stateful components

export class MySchedule extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            "key_dates": [],
            "course_code": "",
            "term_code": ""
        };

        // Binds
        this.assignColoursToData = this.assignColoursToData.bind(this);
        this.setColoursToStorage = this.setColoursToStorage.bind(this);
        this.standardiseExamsData = this.standardiseExamsData.bind(this);
        this.openExamDetails = this.openExamDetails.bind(this);
        this.handleTimetableClick = this.handleTimetableClick.bind(this);
        this.getExamModalButtons = this.getExamModalButtons.bind(this);
        this.handleTimetablePrint = this.handleTimetablePrint.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        // get schedule data from storage
        var schedule_storage = squiz.fn.getStorage('getmyschedule', 'session', 'json');

        // get colour data from storage
        var colour_storage = squiz.fn.getStorage('getallstorage', 'session', 'json');
        colour_storage = colour_storage['data']['coursecolours'];

        // get course data from storage
        // using getmycourses data to its standardised across pages
        var courses_storage = squiz.fn.getStorage('getmycourses', 'session', 'json');
        var programs = courses_storage['data']['programs'];


        // Get course and term codes for timetable links
        var teaching_periods = null;
        var course_code = false;
        var termCode = '';
        if(typeof programs != 'undefined'){
            if(typeof programs[0] != 'undefined'){
                termCode = programs[0]['admitTerm'];
                if(typeof programs[0]['teachingPeriods'] != 'undefined'){
                    teaching_periods = programs[0]['teachingPeriods'];
                    if(typeof teaching_periods[0] != 'undefined'){
                        if(typeof teaching_periods[0]['code'] != 'undefined'){
                            course_code = teaching_periods[0]['code'];
                        }
                    }
                }
            }
        }

        if(course_code){
            this_component.setState({
                "course_code": course_code,
                "term_code": termCode
            });
        }

        // Map colours from course codes
        var mapped_course_codes = {};
        if(typeof programs != 'undefined' && programs.length > 0){
            if(typeof programs[0]['teachingPeriods'] != 'undefined' ){
                // compile course codes for this data
                for(var index = 0; index < programs.length; index++){
                    for(var teachingPeriods_index = 0; teachingPeriods_index < programs[index]['teachingPeriods'].length; teachingPeriods_index++){
                        var this_course = programs[index]['teachingPeriods'][teachingPeriods_index]['courses'];
                        mapped_course_codes = squiz['fn']['colour']['compileCourseCodes'](this_course, mapped_course_codes);
                    }
                }
            }
        }

        var codes_match = false;
        // check if colour_storage codes match the mapped_course_codes
        var mapped_course_codes_keys = Object.keys(mapped_course_codes).sort();
        // undefined colour_storage will throw an error, so make sure it's available before checking
        if(typeof colour_storage != 'undefined'){
            var colour_storage_keys = Object.keys(colour_storage).sort();
            codes_match = JSON.stringify(mapped_course_codes_keys) === JSON.stringify(colour_storage_keys);
        }

        if(!colour_storage || !codes_match){
            // if no local colour schemes, assume none have been set up.
            // set random colours to the data based on course codes
            mapped_course_codes = squiz['fn']['colour']['randomlyAssignColoursToCourseCodes'](mapped_course_codes, GSP_DATA_COLOUR_SCHEMES);
            //mapped_course_codes = this_component.randomlyAssignColoursToCourseCodes(mapped_course_codes);

            // write 
            // write new colour scheme back to gatekeeper
            helpers.setColoursToStorage(mapped_course_codes);
        } else {
            mapped_course_codes = colour_storage;
        }
        
        // aplpy colour schemes to the data
        var cleansed_exams_data = this_component.standardiseExamsData(schedule_storage['data']['exams']);
        schedule_storage['data']['exams'] = cleansed_exams_data;
        schedule_storage = this_component.assignColoursToData(schedule_storage['data'], mapped_course_codes);

        // process key dates
        this_component.processKeyDates(schedule_storage['keyDates']);
        // process my schedule
        this_component.processMySchedule(schedule_storage['events'], schedule_storage['exams']);
    }

    calculateExamEnd(exam, start_date) {
        var this_component = this;
        var end_date = start_date;

        // Check reading time
        if (exam["readingTime"]) {
            end_date = this_component.addExamTime(exam["readingTime"], end_date);
        }

        // Check writing time
        if (exam["writingTime"]) {
            end_date = this_component.addExamTime(exam["writingTime"], end_date);
        }

        // Format result and return
        exam["end"] = end_date.format("YYYY-MM-DDTHH:mm:ss+10:00");

        return exam;
    }

    addExamTime(time_string, exam_date) {
        // Check for dual times
        var time_groups = time_string.split(' and ');

        // Parse time information
        time_groups.forEach(function(group) {
            var group_data = group.split(' ');
            var extra_time = parseInt(group_data[0]);
            var time_measure = group_data[1];

            // Add extra time to provided date
            exam_date = exam_date.add(extra_time, time_measure);
        });

        return exam_date;
    }

    standardiseExamsData(exam_data){
        var this_component = this;

        if (exam_data != null) {
            var exams_filtered = [];
            
            if(exam_data.length > 0){
                exam_data.forEach(exam_item => {
                    if (
                        !(Object.keys(exam_item).indexOf("ExamNotes") > -1) &&
                        !(Object.keys(exam_item).indexOf("ExamFooter") > -1)
                    ) {
                        if (Array.isArray(exam_item)) {
                            exams_filtered = exams_filtered.concat(exam_item);
                        }
                    }
                });
        
                var exams_remapped = [];
        
                // update exams
                var exams_updated = exams_filtered.map(function(item, item_index){
                    return {
                        campus: item["Campus"],
                        course: "",
                        courseTitle: item["Exam"],
                        date: item["Date"],
                        end: "",
                        locationNumber: item["Venue"],
                        readingTime: item["Reading_Time"],
                        start: "",
                        time: item["Start_Time"],
                        writingTime: item["Writing_Time"],
                        duration: item["Duration"],
                        courseCode: "",
                        typeName: "Exam",
                        exam_index: item_index
                    }
                });

                exams_updated.forEach(updated_exam => {
                    if (updated_exam["courseTitle"] != null) {
                        var title_split = updated_exam["courseTitle"].split(' ');
                        updated_exam["courseCode"] = title_split[0];
                    }
                    if(title_split != null) {
                        var course_title = title_split.splice(1, title_split.length).join(' ');
                    }
                    updated_exam["courseTitle"] = course_title;

                    // Check for invalid time
                    
                    if(isNaN(updated_exam["time"][0])) {
                        updated_exam["showTimeRaw"] = true;
                    } else {
                        updated_exam["showTimeRaw"] = false;
                    }
                    
                    // This will always show the right time and doesn't need timezone adjustments
                    // "Saturday 25/1/2020 12:00pm"
                    var start_string = updated_exam["date"];
                    
                    // Online campus does not always provide a valid time value
                    if(!updated_exam["showTimeRaw"]) {
                        start_string += " " + updated_exam["time"];
                    }
                    var start_moment = moment(start_string, "dddd D MMM YYYY HH:mma");
                    var start_moment_formatted = start_moment.format("YYYY-MM-DDTHH:mm:ss+10:00");

                    updated_exam["start"] = start_moment_formatted;

                    // Get end time of exam
                    updated_exam = this_component.calculateExamEnd(updated_exam, start_moment);
        
                    exams_remapped.push(updated_exam);
                });
            }

            return exams_remapped;
        } else {
            return null;
        }
        
    }


    //
    // Events
    //

    openExamDetails(event) {
        event.preventDefault();

        var target_link = event['target'];
        var exam_index = target_link.getAttribute('data-index');

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];
        var modal_content = this_component.prepareExamModal(exam_index);
        var modal_buttons = this_component.getExamModalButtons();

        // Get modal data
        var modal_data = {
            'title': 'Exam details',
            'class': 'modal-exams',
            'content': modal_content,
            'buttons': modal_buttons
        };

        // Set modal content and display
        helpers.setModalContent(modal_data);
    }


    //
    // Functions
    //
    assignColoursToData(data, mapped_course_codes){
        var updated_data = data;
        var updated_keyDates = data['keyDates'];
        var updated_schedule = data['events'];
        var updated_exams = data['exams'];
        var default_scheme = {"name": "default", "code": "#000000"};
        // update keydates
        if (updated_keyDates != null) {
            for(var index = 0; index < updated_keyDates.length; index++){
                var this_course_code = updated_keyDates[index]['courseCode'];
                var colour_scheme = mapped_course_codes[this_course_code];
                if(typeof colour_scheme != 'undefined'){
                    updated_keyDates[index]['colour'] = colour_scheme;
                } else {
                    updated_keyDates[index]['colour'] = default_scheme;
                }
            }
        }
        // update schedule
        if (updated_schedule != null) {
            for(var index = 0; index < updated_schedule.length; index++){
                var this_course_code = updated_schedule[index]['courseCode'];
                var colour_scheme = mapped_course_codes[this_course_code];
                if (typeof colour_scheme != "undefined") {
                    updated_schedule[index]["colour"] = colour_scheme;
                } else {
                    updated_schedule[index]["colour"] = default_scheme;
                }
            }
        }

        // update exams
        if (updated_exams != null) {
            for(var index = 0; index < updated_exams.length; index++){
                var this_course_code = updated_exams[index]['courseCode'];
                var colour_scheme = mapped_course_codes[this_course_code];
                if (typeof colour_scheme != "undefined") {
                    updated_exams[index]["colour"] = colour_scheme;
                } else {
                    updated_exams[index]["colour"] = default_scheme;
                }
            }
        }


        updated_data["keyDates"] = updated_keyDates;
        updated_data["events"] = updated_schedule;
        updated_data["exams"] = updated_exams;

        return updated_data;
    }
    setColoursToStorage(mapped_course_codes) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var colour_code_data = mapped_course_codes;

        // write back to local storage
        // first get latest storage object
        var colour_key = squiz['vars']['store_id'] + 'getallstorage';
        var colour_storage = JSON.parse(getStorage('session', colour_key));
        colour_storage['data']['coursecolours'] = colour_code_data;
        setStorage('session', colour_key, colour_storage);

        //
        // place to write back to gatekeeper API
        //
        var gatekeeper_options = {
            "source": "setcoursecolours,1",
            "data": colour_code_data,
            "success": function(response){
                
            }   
        };
        helpers.setGatekeeperData(gatekeeper_options);
    }


    processKeyDates(data){
        var this_component = this;
        var grouped_dates = data.reduce(function(accumulator, object){
            var current_date = object['date'];
            if(!accumulator[current_date]) {
                accumulator[current_date] = [];    
            }
            accumulator[current_date].push(object);

            return accumulator;
        }, []);

        this_component.setState({
            "key_dates": grouped_dates
        });
    }

    processMySchedule(schedule, exams){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var schedule_data = {
            'my_schedule': schedule,
            'my_exams': exams
        };

        helpers.updateMySchedule(schedule_data);
    }

    renderKeyDates() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var key_dates = this_component['state']['key_dates'];
        var key_dates_by_date = [];

        var no_data_message = portal_context['configuration']['system_messages']['nodata']['keyDates'];
        
        // kill any events that are in the past
        if (key_dates != null) {
            var all_dates = Object.keys(key_dates);
            for(var index = 0; index < all_dates.length; index++){
                var target_date = all_dates[index];
                var this_date = makeDate(target_date);
                
                if(!this_date.isBefore(makeDateNow(), 'day')){
                    key_dates_by_date.push(key_dates[target_date]);
                }
            }
        }

        var key_date_url = helpers.getDynamicLinkUrlById('916723');

        var key_dates_list = key_dates_by_date.map(function(date_group, date_group_index){
            var deadline_types = [];

            // Group same-date events by descriptions
            for(var index = 0; index < date_group.length; index++) {
                var current_date = date_group[index];
                var date_description = current_date['description'];
                var safe_description = date_description.replace(/ /g, '_').toLowerCase();

                // Handle the first encounter
                if(typeof(deadline_types[safe_description]) === 'undefined') {
                    deadline_types[safe_description] = [];
                }

                deadline_types[safe_description].push(current_date);
            }

            // Process new group
            var list_elements = [];
            var all_types = Object.keys(deadline_types);

            for(var index = 0; index < all_types.length; index++) {
                var current_type = all_types[index];
                var type_data = deadline_types[current_type];

                // Collect course codes
                var course_codes = type_data.map(function(group, group_index){
                    var code = group['courseCode'];
                    var colour = group['colour'];
                    var code_class = 'code--' + colour['name'];
                    var code_separator = ', ';
    
                    if(group_index === type_data.length - 1) {
                        code_separator = '';
                    }
    
                    return <span key={group_index} className="key-dates__code"><span className={code_class}>{code}</span>{code_separator}</span>
                });

                // Construct information
                var date_format = 'Do MMMM YYYY';
                var date_data = {
                    "date": makeDate(type_data[0]['date'], date_format),
                    "description": type_data[0]['description']
                };

                // Assign to variable and add to array instead of using a return
                // so we can iterate multiple times and not break free
                var list_item = (
                    <li className={'key-dates__item schedule--grouped'} key={index}>
                        <span className="key-dates__link">
                            <span className="key-dates__date">{date_data['date']}</span>
                            <span className="key-dates__title">{date_data['description']}: {course_codes}</span>
                        </span>
                    </li>
                );

                list_elements.push(list_item);
            }

            // Return elements
            return list_elements.map(function(element, element_index) {
                return element;
            });
        });

        return (
            <>
            <span className="schedule__heading">Upcoming Key Dates</span>
            {key_dates_by_date.length > 0 && key_dates_by_date != null ? (
                <ul className="key-dates__list">
                {key_dates_list}
                </ul>
            ) : (
                <p>{no_data_message}</p>
            )}
                <a href={key_date_url} className="schedule__btn--key-dates">View more key dates</a>
            </>
        );
    }

    renderEventLocation(item_data) {
        var campus_map_url = item_data['campus_map_url'];
        var location_number = item_data['locationNumber'];
        var campus = item_data['campus'];

        if(location_number !== 'TBA') {
            var event_location_text = <span className="schedule__location-text">{location_number} - {campus}</span>;
            var event_location = event_location_text;

            if(location_number === "ONLINE") {
                event_location_text = <span className="schedule__location-text">{location_number}</span>
                event_location = event_location_text;
            }

            // Wrap a URL if it exists
            if(campus_map_url) {
                event_location = 
                    <a className="schedule__location-link" href={campus_map_url}>
                        {event_location_text}
                    </a>;
            }

            return (
                <div className="schedule__location">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20">
                        <g fill="#3E3E3E" fillRule="nonzero">
                            <path d="M5.896 18.904C5.656 18.504 0 9.736 0 6.4a6.4 6.4 0 1 1 12.8 0c0 3.336-5.656 12.104-5.896 12.504a.608.608 0 0 1-.496.296.592.592 0 0 1-.512-.296zm.512-17.712A5.216 5.216 0 0 0 1.2 6.4c0 2.264 3.384 7.832 5.208 11.008 1.824-3.2 5.216-8.744 5.216-11.008a5.216 5.216 0 0 0-5.216-5.208z"/>
                            <path d="M6.408 10.008a3.608 3.608 0 1 1 0-7.216 3.608 3.608 0 0 1 0 7.216zm0-6.016a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8z"/>
                        </g>
                    </svg>
                    {event_location}
                </div>
            );
        }

        return null;
    }

    renderMySchedule() {
        var this_component = this;
        var portal_context = this_component['context'];
        var set_date = portal_context['selected_date'];
        var my_schedule = portal_context['my_schedule'];
        var my_exams = portal_context['my_exams'];

        var no_data_message = portal_context['configuration']['system_messages']['nodata']['mySchedule'];
        var campus_maps_data = portal_context['configuration']['campus_maps'];

        if (my_schedule != null) {
            if (my_exams != null) {
                my_schedule = my_schedule.concat(my_exams);
            }
    
            // sort by date 
            my_schedule = my_schedule.sort(function(a, b) {

                return makeDate(a.start).unix() - makeDate(b.start).unix();
            });
        }

        var section_title = '';
        var my_schedule_by_date = [];

        // Check for selected day
        var date_format = 'YYYY-MM-DD';
        var set_date_formatted = set_date.format(date_format);
        var date_today = makeDateNow();
        var date_today_formatted = date_today.format(date_format);

        if (set_date_formatted === date_today_formatted){
            section_title = 'Today';
        } else {
            section_title = set_date.format("Do MMMM YYYY");
        }

        // only show events that are on the set day
        if (my_schedule != null) {
            for(var index = 0; index < my_schedule.length; index++){
                if (!Array.isArray(my_schedule[index]) && Object.keys(my_schedule[index]).length > 1){
                    var this_date = makeDate(my_schedule[index]['start']);
                    var this_date_formatted = this_date.format(date_format);

                    // if the event matches the set date (from the calendar)
                    if(this_date_formatted === set_date_formatted){
                        // cleans the data somewhat
                        // change to lowercase, replace nbsp's, and remove 'campus' from the value
                        // they need to match up to the data structure in the config JS
                        if (my_schedule[index]['campus']) {
                            var this_campus = my_schedule[index]['campus'].toLowerCase().replace(/ /g, '_').replace('_campus', '');
                            if(typeof campus_maps_data[this_campus] != 'undefined'){
                                my_schedule[index]['campus_map_url'] = campus_maps_data[this_campus];
                            }
                        }
                        my_schedule_by_date.push(my_schedule[index]);
                    }
                }
            }
        }

        var date_time_format = 'hh:mm a';

        return (
            <>
                <span className="schedule__heading">{section_title}</span>
                {my_schedule_by_date.length > 0 && my_schedule_by_date != null ? (
                    <ul className="schedule__list">
                    {my_schedule_by_date.map((item, index) => (
                        <li className={'schedule__item schedule--' + item['colour']['name']} key={index}>
                            <div className="schedule__header">
                                <span className="schedule__code">{item.courseCode}</span>
                                <div className="schedule__info">
                                {item.url ? (
                                    <a href={item.url} className="schedule__link">{item.courseTitle}</a>
                                ): (
                                    <span className="schedule__link">{item.courseTitle}</span>
                                )}
                                
                                    {item.showTimeRaw ? (
                                        <span className="schedule__time">{item.time}</span>
                                    ): (
                                        <span className="schedule__time">{makeDate(item.start, date_time_format)} - {makeDate(item.end, date_time_format)}</span>
                                    )}

                                    {item.typeName === "Exam" &&
                                    <div className="schedule__exam-wrapper">
                                        <ul className="schedule__exam-list">

                                            {item['duration'] ? (
                                                <li className="schedule__exam-item">
                                                    <span className="schedule__exam-label">Duration: </span>
                                                    <span className="schedule__exam-info">{item['duration']}</span>
                                                </li>
                                            ) : null}
                                            
                                            {item['writingTime'] ? (
                                                <li className="schedule__exam-item">
                                                    <span className="schedule__exam-label">Writing time: </span>
                                                    <span className="schedule__exam-info">{item['writingTime']}</span>
                                                </li>
                                            ) : null}
                                            
                                            {item['readingTime'] ? (
                                                <li className="schedule__exam-item">
                                                    <span className="schedule__exam-label">Reading time: </span>
                                                    <span className="schedule__exam-info">{item['readingTime']}</span>
                                                </li>
                                            ) : null}
                                            
                                        </ul>
                                        <a href="#" className="schedule__link" onClick={this_component.openExamDetails} data-index={item['exam_index']}>View full details</a>
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className="schedule__footer">
                                <span className="schedule__type">{item.typeName}</span>
                                {this_component.renderEventLocation(item)}
                            </div>
                            {item['classNotes'] && item['classNotes'].length > 0 && (
                                <div className="schedule__footer">
                                    <span className="schedule__type">Notes</span>
                                    <div>
                                        {item['classNotes'].map((note, index) => {
                                            return <div key={index}>{note}</div>
                                        })}
                                    </div>
                                </div>
                            )}

                        </li>
                    ))}
                    </ul>
                ) : (
                    <p>{no_data_message}</p>
                )}
            </>
        );
    }

    renderTimetableButtons() {
        var this_component = this;
        var portal_context = this_component['context'];

        var weekly_timetable_link = portal_context['helpers'].getDynamicLinkUrlById('889843');
        var full_timetable_link = portal_context['helpers'].getDynamicLinkUrlById('901712');
        
        var full_timetable_code = this_component['state']['course_code'];
        var full_timetable_term_code = this_component['state']['term_code'];
        if(!full_timetable_code) {
            full_timetable_code = '';
        }

        full_timetable_link = full_timetable_link.replace('__tc__', full_timetable_term_code).replace('__pc__', full_timetable_code);


        return (
            <div className="schedule__buttons">
                <a href={weekly_timetable_link} className="schedule__btn">Weekly timetable</a>
                <a href={full_timetable_link}  className="schedule__btn" onClick={this_component.handleTimetableClick}>Full timetable</a>
            </div>
        );

    }

    handleTimetableClick(event){
        var this_component = this;
        var has_course_code = this_component['state']['course_code'];
        if(!has_course_code){
            event.preventDefault();
            alert('You have no current enrolment schedule');
            return false;
        }
        return;
    }

    handleTimetablePrint(event) {

        // Add element if it's not already there
        if ( document.querySelector('.printable-content') === null ) {
            var new_child = document.createElement("div");
            new_child.classList.add('printable-content');
            document.querySelector('.page-wrapper').appendChild(new_child);
        }

        // Clear it
        var print_area = document.querySelector('.printable-content');
        while (print_area.firstChild){
            print_area.removeChild(print_area.firstChild);
        }

        var content = document.querySelector('.modal__section').innerHTML;
        document.querySelector('.printable-content').innerHTML = '<h1>Exam Timetable</h1>' + content;

        window.print();
    }



    //
    // Render
    //

    prepareExamModal(exam_index) {
        var schedule_data = squiz.fn.getStorage('getmyschedule', 'session', 'json');
        var exams_data = schedule_data['data']['exams'];
        var exam_notes = exams_data[0]['ExamNotes'];
        var exam_content = exams_data[1][exam_index];
        var exam_footer = exams_data[2]['ExamFooter'];

        if(exam_notes) {
            exam_notes = {
                '__html': exam_notes
            };
        }

        if(exam_footer) {
            exam_footer = {
                '__html': exam_footer
            };
        }

        if( exam_content.hasOwnProperty('Accessible_Conditions') && typeof(exam_content['Accessible_Conditions']) === 'object' ) {
 
            var newArr = [];
            var accessible_conditions = exam_content['Accessible_Conditions'][0];
            var conditions_type = getVarType(accessible_conditions);

            if(conditions_type === 'object') {
                Object.keys(accessible_conditions).map((value, key) => {
                    var condition = accessible_conditions[key + 1];
                    newArr.push(condition);
                })
            } else {
                accessible_conditions.forEach(value => {
                    newArr.push(value);
                });
            }                            

            exam_content['Accessible_Conditions'] = newArr;
        }

        // Get materials
        var materials_permitted = null;

        if(exam_content['Materials_Permitted'] !== '') {
            var materials_raw = exam_content['Materials_Permitted'];

            if (materials_raw) {
                if (typeof(materials_raw) === 'string') {
                    materials_permitted = <span>{materials_raw}</span>;

                } else if (typeof(materials_raw) === 'object') {
                    var materials_obj = materials_raw[0];
                    var materials_items = Object.keys(materials_obj).map(function(item, item_index) {
                        var material = materials_obj[item_index + 1];

                        return (
                            <li key={item_index}>
                                <span>{material}</span>
                            </li>
                        );
                    });

                    materials_permitted = <ul>{materials_items}</ul>;
                }
            }
        }

        // Get conditions
        var exam_conditions = null;

        if(exam_content['Exam_Conditions'] !== '') {
            var exam_conditions_raw = exam_content['Exam_Conditions'][0];
            exam_conditions = Object.keys(exam_conditions_raw).map(function(item, item_index) {
                var condition = exam_conditions_raw[item_index + 1];

                return (
                    <li key={item_index}>
                        <span>{condition}</span>
                    </li>
                );
            });
        }

        // Get important notes
        var important_notes = null;

        if(exam_content['Important_Notes'] !== '') {
            important_notes = {
                '__html': exam_content['Important_Notes']
            };
        }

        // Get instructions
        var instructions = null;

        if(exam_content['Instructions_To_Students'] !== '') {
            instructions = {
                '__html': exam_content['Instructions_To_Students']
            };
        }

        return (
            <div className="exams-modal__wrapper">
                <div className="exams-modal__notes" dangerouslySetInnerHTML={exam_notes}></div>
                <div className="exams-modal__details">
                    <span className="exams-modal__title">{exam_content['ExamTitle']} </span>
                    <span className="exams-modal__sub-title">{exam_content['Status']}</span>
                    <ul className="exams-modal__list">
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Exam:</span>
                            <span>{exam_content['Exam']}</span>
                        </li>
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Date:</span>
                            <span>{exam_content['Date']}</span>
                        </li>
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Time:</span>
                            <span>{exam_content['Start_Time']}</span>
                        </li>
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Duration:</span>
                            <span>{exam_content['Duration']}</span>
                        </li>
                        
                        {exam_content['Writing_Time'] ? (
                            <li className="exams-modal__item">
                                <span className="schedule__exam-label">Writing Time:</span>
                                <span>{exam_content['Writing_Time']}</span>
                            </li>
                        ) : null}
                        
                        {exam_content['Reading_Time'] ? (
                            <li className="exams-modal__item">
                                <span className="schedule__exam-label">Reading Time:</span>
                                <span>{exam_content['Reading_Time']}</span>
                            </li>
                        ) : null}

                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Campus:</span>
                            <span>{exam_content['Campus']}</span>
                        </li>
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Venue:</span>
                            <span>{exam_content['Venue']}</span>
                        </li>

                        {(exam_content['Accessible_Conditions'] && !Array.isArray(exam_content['Accessible_Conditions']) ) && 
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Accessible Conditions:</span>
                            <span>{exam_content['Accessible_Conditions']}</span>
                        </li>
                        }

                        {(exam_content['Accessible_Conditions'] && Array.isArray(exam_content['Accessible_Conditions']) ) && 
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Accessible Conditions:</span>
                            <ul style={{ listStyleType: "none" }}>
                                {exam_content['Accessible_Conditions'].map((value, key) => {
                                    if(value !== "\n") {
                                        value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
                                        return <li key={key} dangerouslySetInnerHTML={{ __html: value }} />;
                                    }
                                })}
                            </ul>
                        </li>
                        }

                        {exam_conditions ? (
                            <li className="exams-modal__item">
                                <span className="schedule__exam-label">Conditions:</span>
                                <ol>{exam_conditions}</ol>
                            </li>
                        ) : null}

                        {exam_content['Materials_Permitted'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Materials Permitted:</span>
                            {materials_permitted}
                        </li>
                        ) : null}

                        {exam_content['Important_Notes'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Important Notes:</span>
                            <span dangerouslySetInnerHTML={important_notes}></span>
                        </li>
                        ) : null}

                        {exam_content['Instructions_To_Students'] ? (
                        <li className="exams-modal__item">
                            <span className="schedule__exam-label">Instruction to Students:</span>
                            <span dangerouslySetInnerHTML={instructions}></span>
                        </li>
                        ) : null}
                    </ul>
                </div>
                {exam_footer &&
                <div className="exams-modal__footer">
                    <div dangerouslySetInnerHTML={exam_footer}></div>
                </div>
                }
            </div>
        );   
    }

    getExamModalButtons() {
        return (
            [
                {
                    'class': 'btn btn-primary',
                    'label': 'Print / Download PDF',
                    'clickHandler': this.handleTimetablePrint,
                    'action': 'custom'
                },
                {
                    'class': 'btn btn-secondary',
                    'label': 'Cancel',
                    'clickHandler': null,
                    'action': 'close'
                }
            ]
        );
    }

    render() {
        var this_component = this;
        var key_dates = this_component.renderKeyDates();
        var my_schedule = this_component.renderMySchedule();
        var timetable_buttons = this_component.renderTimetableButtons();


        return (
            <>
                 <div className="schedule__main">
                    <ContextualMessage id="my_schedule" />
                    {key_dates}
                    {my_schedule}
                 </div>
                
                {timetable_buttons}
            </>
        );
    }

};

MySchedule.contextType = PortalContext;